const typographySizes = {
  // Text sizes with mobile variants
  text: {
    tekstSize1: {
      size: { mobile: 1.2, desktop: 1.2 },
      lineHeight: 1,
    },
    tekstSize2: {
      size: { mobile: 1.4, desktop: 1.4 },
      lineHeight: 1,
    },
    tekstSize3: {
      size: { mobile: 1.8, desktop: 1.8 },
      lineHeight: 1,
    },
    tekstSize4: {
      size: { mobile: 1.6, desktop: 2.2 },
      lineHeight: 0.95,
    },
    tekstSize5: {
      size: { mobile: 2.5, desktop: 2.5 },
      lineHeight: 1,
    },
    tekstSize6: {
      size: { mobile: 2.2, desktop: 2.9 },
      lineHeight: 1.1,
    },
    tekstSize7: {
      size: { mobile: 2.9, desktop: 6.1 },
      lineHeight: 0.85,
    },
    tekstSize8: {
      size: { mobile: 2.9, desktop: 7.1 },
      lineHeight: 0.85,
    },
    tekstSize9: {
      size: { mobile: 3.4, desktop: 9.5 },
      lineHeight: 0.85,
    },
  },
};

export default typographySizes;
